






import { Vue, Prop, Component } from "vue-property-decorator";
@Component({})
export default class RingProgress extends Vue {
  @Prop({ default: 0 })
  progress;

  renderRightRate = (rate: number) => {
    if (rate < 50) {
      return `transform: rotate(${3.6 * rate}deg);`;
    } else {
      return "transform: rotate(0);border-color: #54c4fd;";
    }
  };

  renderLeftRate = (rate: number) => {
    if (rate >= 50) {
      return `transform: rotate(${3.6 * (rate - 50)}deg);`;
    }
  };
}
